import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useSearchParams } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import "./FarmReportHistory.css";
import BASE_URL, { FRONTEND_BASE_URL } from "../../../config/apiConfig";

export default function FarmReportHistory() {
  const [searchParams] = useSearchParams();
  const fieldId = searchParams.get("fieldId");
  const [reports, setReports] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  useEffect(() => {
    async function fetchReports() {
      try {
        const res = await fetch(
          `${BASE_URL}/api/admin/fields/${fieldId}/report-history/`
        );
        const data = await res.json();
        setReports(data);
      } catch (err) {
        console.error("Error fetching history:", err);
      }
    }
    fetchReports();
  }, [fieldId]);

  const availableDates = reports.map((r) =>
    new Date(r.report_date).toDateString()
  );

  const handleDateSelect = (date) => {
    const selected = date.toDateString();
    const report = reports.find(
      (r) => new Date(r.report_date).toDateString() === selected
    );
    if (report) {
      setSelectedDate(selected);
      setPdfUrl(report.pdf_url);
    } else {
      setSelectedDate(selected);
      setPdfUrl(null);
    }
    setCalendarOpen(false); // close calendar after selection
  };

  return (
    <div className="farm-report-container">
      {/* Sidebar */}
      <div className="farm-sidebar">
        <h2 className="sidebar-title">Farm Report History</h2>

        {/* Date picker placeholder */}
        <div
          className="date-placeholder"
          onClick={() => setCalendarOpen(!calendarOpen)}
        >
          {selectedDate ? selectedDate : "Select Report Date"}
        </div>

        {/* Calendar dropdown */}
        {calendarOpen && (
          <Calendar
            onClickDay={handleDateSelect}
            tileDisabled={({ date }) =>
              !availableDates.includes(date.toDateString())
            }
            className="calendar-dropdown"
          />
        )}

        {/* Download button */}
        {pdfUrl && (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="download-btn"
          >
            Download PDF
          </a>
        )}

        {pdfUrl && (
          <button
            className="interactive-btn"
            onClick={() =>
              window.open(
                `${FRONTEND_BASE_URL}/reports/farmology_report.html?fieldId=${fieldId}`,
                "_blank"
              )
            }
          >
            🔍 Check Interactive Report
          </button>
        )}
      </div>

      {/* PDF Viewer */}
      <div className="pdf-viewer-container">
        {pdfUrl ? (
          <div className="pdf-viewer-wrapper">
            <iframe
              src={pdfUrl}
              title="Farm Report PDF"
              className="pdf-viewer"
            ></iframe>
          </div>
        ) : (
          <p className="placeholder-text">Select a date to view the report.</p>
        )}
      </div>
    </div>
  );
}
